import { setValueValue } from '@databases/collab/y-database';
import { type Database } from '@databases/model/database';
import { type FieldType, type SelectOptionJSON } from '@databases/model/field';
import { type AllValueJSON } from '@databases/model/value';

export function createEntry(
  ydb: Database,
  input: {
    entryId: string;
    fieldChanges: Array<{ fieldId: string; fieldType: FieldType; value: AllValueJSON }>;
    selectOptionsToAdd: Array<{ fieldId: string; option: SelectOptionJSON }>;
  }
): void {
  ydb.mutate((db) => {
    const entry = db.addEntry(input.entryId);
    for (const [fieldId, value] of Object.entries(db.defaultEntry.toJSON().values)) {
      setValueValue(entry.setValue(fieldId, value.type), value);
    }
    for (const { fieldId, option } of input.selectOptionsToAdd) {
      const field = db.fieldsById[fieldId];
      if (field) {
        field.selectOptions.add(option);
      }
    }
    for (const fieldChange of input.fieldChanges) {
      setValueValue(
        entry.setValue(fieldChange.fieldId, fieldChange.fieldType),
        fieldChange.value
      );
    }
  });
}
